import '@common/styles/components/imprint.pcss';

function EnglishImprint() {
  return (
    <div className="imprint txt-small">
      <h2>
        Imprint
      </h2>
      <article>
        <section>
          <h5>
            STIEBEL ELTRON GmbH &amp; Co. KG
          </h5>
        </section>
        <section>
          <span>
            <strong>
              Address:
            </strong>
            <br />
            Dr.-Stiebel-Strasse 33
            <br />
            37603 Holzminden, Germany
            <br />
            Email: info@stiebel-eltron.com
          </span>
        </section>
        <section>
          <h5>
            Company registered at
          </h5>
          <span>
            Amtsgericht Hildesheim
            <br />
            Registernummer: HRA 110363
            <br />
            Umsatzsteuer-Identifikationsnummer: DE811150571
          </span>
        </section>
        <section>
          <h5>
            Partner with personal liability
          </h5>
          <span>
            STIEBEL ELTRON Geschäftsführungsgesellschaft mbH
            <br />
            Dr.-Stiebel-Straße 33
            <br />
            37603 Holzminden
          </span>
        </section>
        <section>
          <h5>
            Company registered at
          </h5>
          <span>
            Amtsgericht Hildesheim
            <br />
            Registernummer: HRB 110401
          </span>
        </section>
        <section>
          <h5>
            Authorised management
          </h5>
          <span>
            Dr. Kai Schiefelbein, Heinz-Werner Schmidt, Martin Repschlaeger
          </span>
        </section>
        <section>
          <h5>
            Chairman of the supervisory board
          </h5>
          <span>
            Dr. Ulrich Stiebel
          </span>
        </section>
        <section>
          <h5>
            Editor
          </h5>
          <span>
            Dominik Scholz
            <br />
            <a href="mailto:dominik.scholz@stiebel-eltron.de">
              dominik.scholz@stiebel-eltron.de
            </a>
          </span>
        </section>
        <section>
          <h5>
            Legal notice/warranty
          </h5>
          <span>
            In spite every care having been taken in the creation of this medium, no warranty is
            given or implied regarding correctness of content. Information concerning equipment
            levels and specification are subject to modification. The equipment features described
            in this medium are not stated as agreed properties of our products. Due to our policy of
            ongoing improvement, some features may have subsequently been changed or even removed.
            <br />
            <br />
            Our experts will be happy to advise you about currently applicable equipment
            characteristics. Pictorial illustrations in this brochure only represent application
            examples. The illustrations also contain installation components, accessories and
            special equipment that are not part of the standard delivery.
          </span>
        </section>
        <section>
          <h5>
            Liability notice
          </h5>
          <span>
            We are not responsible for damages of any kind that may develop due to information which
            has been provided on this website.
            <br />
            <br />
            In spite of careful contents checking, no liability is accepted for the contents of
            external links. Only the operators of external links are responsible for the content of
            linked pages.
          </span>
        </section>
        <section>
          <h5>
            Consumer arbitration | notice subject to § 36 para. 1 VSBG
          </h5>
          <span>
            We are not willing and not obliged to participate in an alternative dispute resolution
            at a consumer arbitration board
          </span>
        </section>
        <section>
          <h5>
            Copyrights
          </h5>
          <span>
            The entire contents of this website are copyright protected. All texts, illustrations
            and sound files are protected under copyright laws and other laws for the protection of
            intellectual property. Contents may not be copied for commercial purposes or for
            distribution to third parties. Nor may contents be modified or used on other websites.
            This does not apply if we have expressly made image or graphical material available to
            you for further use.
          </span>
        </section>
      </article>
    </div>
  );
}

export default EnglishImprint;
